import React from 'react';
import ResetPassword from '../../components/RecoverPassword/RecoverPassword';
import Header from '../../components/Header/Header';

const RecoverPasswordPage: React.FC = () => {
	return (
		<>
			<Header>{''}</Header>

			<ResetPassword />
		</>
	);
};

export default RecoverPasswordPage;
